import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import './Guest.css';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    cityName: '',
    password: ''
  });
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect if already logged in
    if (localStorage.getItem('login')) {
      navigate('/');
    }

    // Fetch cities for dropdown
    const fetchCities = async () => {
      try {
        const response = await fetch('https://hospital.rozeetechnist.com/hospital-api/getCities.php');
        const result = await response.json();
        if (result && Array.isArray(result)) {
          setCityOptions(result);
        }
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    fetchCities();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleCityChange = (selectedOption) => {
    setFormData(prevData => ({
      ...prevData,
      cityName: selectedOption ? selectedOption.value : ''
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      toast.error('Please enter Name');
      return;
    }
    if (!formData.mobileNumber.trim()) {
      toast.error('Please enter Mobile Number');
      return;
    }
    if (!formData.cityName) {
      toast.error('Please select City Name');
      return;
    }
    if (!formData.password) {
      toast.error('Please enter Password');
      return;
    }
    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    if (formData.password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);

    // Call register API
    fetch("https://hospital.rozeetechnist.com/hospital-api/register_user.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: formData.name,
        mobile_number: formData.mobileNumber,
        city_id: formData.cityName,
        password: formData.password
      })
    })
      .then((result) => result.json())
      .then((resp) => {
        setLoading(false);
        if (resp.status) {
          toast.success(resp.message || 'Registration successful!');
          // Redirect to login page after successful registration
          setTimeout(() => {
            navigate('/login');
          }, 1500);
        } else {
          toast.error(resp.message || 'Registration failed. Please try again.');
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error during registration:', error);
        toast.error('An error occurred. Please try again.');
      });
  };

  // Logo configuration - set showLogo to true and add logo file to public folder
  const showLogo = false; // Set to true to show logo
  const logoPath = '/logo.png'; // Update this path to your logo file in public folder

  return (
    <div className="guest-container">
      <div className="guest-wrapper">
        {/* Hospital Title with Optional Logo */}
        <div className="guest-header-section">
          {showLogo && (
            <img
              src={logoPath}
              alt="Hospital Logo"
              className="guest-logo"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}
          <h1 className="guest-hospital-name">સુમરા હોસ્પિટલ</h1>
          <p className="guest-subtitle">Donation Management Portal</p>
        </div>

        {/* Register Form */}
        <div className="guest-form-container">
          <h2 className="guest-form-title">Register</h2>

          <form onSubmit={handleSubmit}>
            <div className="guest-input-group">
              <label htmlFor="name" className="guest-label">Name</label>
              <input
                type="text"
                className="guest-input"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />
            </div>

            <div className="guest-input-group">
              <label htmlFor="mobileNumber" className="guest-label">Mobile Number</label>
              <input
                type="tel"
                className="guest-input"
                id="mobileNumber"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                pattern="[0-9]{10}"
                maxLength="10"
                placeholder="Enter 10 digit mobile number"
                required
              />
            </div>

            <div className="guest-select-wrapper">
              <label htmlFor="cityName" className="guest-label">City Name</label>
              <Select
                name="cityName"
                options={cityOptions}
                onChange={handleCityChange}
                placeholder="Select City"
                isClearable
                isSearchable
                classNamePrefix="react-select"
              />
            </div>

            <div className="guest-input-group">
              <label htmlFor="password" className="guest-label">Password</label>
              <input
                type="password"
                className="guest-input"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password (min 6 characters)"
                minLength="6"
                required
              />
            </div>

            <div className="guest-input-group">
              <label htmlFor="confirmPassword" className="guest-label">Confirm Password</label>
              <input
                type="password"
                className="guest-input"
                id="confirmPassword"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm password"
                minLength="6"
                required
              />
            </div>

            <button
              type="submit"
              className="guest-button"
              disabled={loading}
            >
              {loading ? 'Registering...' : 'Register'}
            </button>

            <div className="guest-link-section">
              <p className="guest-link-text">
                Already have an account?{' '}
                <Link to="/login" className="guest-link">
                  Login here
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
